






































export default Vue.extend({
    name: "MobileEditoTile",
    props: {
        titleHtml: {type: String, required: true},
        showPicto5G: {type: Boolean, required: false},
        picto5gSrc: {type: String, required: true},
        attributes: {type: Array, required: true},
        linkLabel: {type: String, required: true},
        link: {type: String, required: true},
        linkTms: {type: Object, required: true}
    }
})
